import React from 'react';
import { Paper, Typography } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleIcon from '@mui/icons-material/People';
import ListIcon from '@mui/icons-material/ListAlt';
import { useTranslation } from 'react-i18next';
import StatCard from '../../../CalculateMoney/StatCard';
import StatCardsRow from '../../../CalculateMoney/StatCardsRow';
import EarningsBarChartPickDate from '../../../CalculateMoney/Charts/EarningsBarChartPickDate';
import { statPaper, statTitle } from '../../../../styles/CalculateMoney/OverviewCommonStyles';

const empty = { totalEarnings: 0, sessionCount: 0, inProgressSessionCount: 0, hourlyEarnings: [] };

export default function OverviewDayViewStaff({ data, date }) {
  const { t } = useTranslation('overview');

  let dailyData = empty;
  if (Array.isArray(data) && data.length > 0 && typeof data[0] === 'object') {
    const flat = data[0];
    dailyData = {
      totalEarnings: flat.totalEarnings ?? 0,
      sessionCount: flat.sessionCount ?? 0,
      inProgressSessionCount: flat.inProgressSessionCount ?? 0,
      hourlyEarnings: flat.hourlyEarnings?.$values ?? [],
    };
  }

  return (
    <>
      <StatCardsRow>
        <StatCard
          icon={<MonetizationOnIcon fontSize="large" />}
          label={t('stats.totalEarnings')}
          value={`${dailyData.totalEarnings} €`}
          color="primary"
        />
        <StatCard
          icon={<PeopleIcon fontSize="large" />}
          label={t('stats.totalSessions')}
          value={dailyData.sessionCount}
          color="success"
        />
        <StatCard
          icon={<ListIcon fontSize="large" />}
          label={t('stats.inProgress')}
          value={dailyData.inProgressSessionCount}
          color="warning"
        />
      </StatCardsRow>
      <Paper elevation={0} sx={statPaper}>
        <Typography variant="subtitle1" sx={statTitle}>
          {date ? t('charts.earningsByHourOnDate', { date }) : t('charts.earningsByHour')}
        </Typography>
        <EarningsBarChartPickDate hourlyEarnings={dailyData.hourlyEarnings} />
      </Paper>
    </>
  );
}